/*
 * Module for keeping updatetokens alive by periodically pinging the server.
 * 
 * The tokens to keep alive are those found on the page combined with any manually
 * requested to be monitored via the monitor() method.
*/

rs.module("ui/framework/updatetoken-monitor",

    [],

    function () {

        var _backendUrl;
        var _identifierDataAttribute;
        var _monitored = [];

        //
        // Initialize
        //
        function initialize(intervalSeconds, identifierDataAttribute, backendUrl) {

            _backendUrl = backendUrl;
            _identifierDataAttribute = identifierDataAttribute;

            // setup a timer to run every intervalSeconds
            setInterval(_runKeepAlive, intervalSeconds * 1000);
        }

        ///
        /// Keep token(s) alive by periodically notifying the server that they are still in use.
        ///
        function monitor(updateTokens) {
            // treat single item as an array with one
            updateTokens = [].concat(updateTokens || []);

            _monitored.push(...updateTokens);
        }

        ///
        /// Stop keeping token(s) alive.
        /// 
        function discard(updateTokens) {
            // treat single item as an array with one
            updateTokens = [].concat(updateTokens || []);

            _monitored = _monitored.filter(item => !updateTokens.includes(item));
        }

        ///
        /// Search the page for updatetoken hidden inputs, sending a Touch request to keep them alive.
        ///
        function _runKeepAlive() {
            var tokens = [];
            $(`[data-${_identifierDataAttribute}="true"]`).each(function () {
                tokens.push($(this).val());
            });

            // merge with any manually monitored tokens
            tokens.push(..._monitored);

            // Make the call to keep the tokens alive
            if (tokens.length > 0) {
                $.post(_backendUrl, { updateTokens: tokens });
            }
        }

        // Exported public API
        var exports = {
            initialize,
            monitor,
            discard
        };

        return exports;
    }
);